import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const SignsOfAging = lazyWithPreload(() => import('./SignsOfAging'))
